export class UTILS__string {
  /**
   * Generates a deterministic 24-character hex ObjectId from a string seed.
   * Pure TypeScript, synchronous, and works in any JavaScript runtime.
   */
  static object_id(seed: string): string {
    let [h1, h2] = [0xdeadbeef, 0x41c6ce57];

    for (let i = 0; i < seed.length; i++) {
      const ch = seed.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }

    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);

    // Third round to derive the remaining 32 bits needed for a 96-bit (24 hex char) ID
    const h3 = Math.imul(h1 ^ h2, 2246822507);

    const hex1 = (h1 >>> 0).toString(16).padStart(8, '0');
    const hex2 = (h2 >>> 0).toString(16).padStart(8, '0');
    const hex3 = (h3 >>> 0).toString(16).padStart(8, '0');

    return `${hex1}${hex2}${hex3}`;
  }
}

export function get_avatar_fallback_from_name(name: string) {
  let out = '';

  name = name.trim();

  let name_parts = name.split(' ');

  name_parts = name_parts.map(part => part.trim());
  name_parts = name_parts.filter(part => part.length > 0);

  if (name_parts.length === 0) {
    //do nothing
  } else if (name_parts.length > 1) {
    out = name_parts[0][0].capitalize() + name_parts[1][0].capitalize();
  } else {
    out = name_parts[0][0].capitalize();
  }

  return out;
}
